import React from 'react';
import './Syles/Usability.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
const Usability=()=>{
    return(
        <div className="usability-home">
            <div className="image-part" data-aos="zoom-in"
              data-aos-delay={100}>

            </div>
            <div className="content">
                <h1>Usability Testing</h1>
                <p>Get video, voice and analytical feedback on designs and prototypes with our user testing tool in just a few clicks.</p>
                <StyledButton btn="Request a demo " styles="nobg-btn"/>
            </div>
        </div>
    )
};
export default Usability ;